<router-outlet></router-outlet>
@if (!deviceDetectorService.isMobile()) {
  <app-reminder></app-reminder>
}
<app-event-socket></app-event-socket>
@if (!deviceDetectorService.isMobile()) {
  <app-banner></app-banner>
}
